import { AlertTriangle } from 'lucide-react';
import { useStore } from '../store';

/**
 * Shown the moment an operator enters an episode (annotate or audit) whose
 * preview video is short enough that the commit guard would reject it
 * ("Encoded payload too short for episode duration"). Catching it up front —
 * instead of after a full annotation pass — saves the operator from wasted
 * work. The single action releases the lease and returns to the home dashboard;
 * there is no dismiss, because the only safe move is to give the episode back.
 *
 * Detection lives in store.ts where the preview duration is first known
 * (`previewDurationMismatch`); see previewDurationCheck.ts for the guard logic.
 */
export function PreviewDurationMismatchModal() {
  const previewDurationMismatch = useStore((s) => s.previewDurationMismatch);
  const acknowledgePreviewDurationMismatch = useStore((s) => s.acknowledgePreviewDurationMismatch);

  if (!previewDurationMismatch) return null;

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 animate-in fade-in duration-200"
      role="dialog"
      aria-modal="true"
      aria-labelledby="preview-duration-mismatch-title"
    >
      <div
        role="document"
        className="rounded-xl border border-brand-border bg-brand-surface p-6 shadow-xl max-w-sm mx-4 animate-in zoom-in-95 duration-200"
      >
        <div className="flex items-start gap-3">
          <div className="mt-0.5 flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-red-500/10 text-red-500">
            <AlertTriangle className="h-5 w-5" />
          </div>
          <div>
            <p id="preview-duration-mismatch-title" className="text-brand-text-primary font-medium">
              此视频数据有问题，无法标注
            </p>
            <p className="mt-2 text-sm text-brand-text-secondary">
              预览视频的实际时长不足以覆盖记录的时长，标注完成后将无法提交。请返回首页并 release
              这条视频。
            </p>
          </div>
        </div>
        <div className="mt-4 flex justify-end">
          <button
            type="button"
            onClick={() => void acknowledgePreviewDurationMismatch()}
            className="rounded-lg bg-brand-orange px-4 py-2 text-sm font-medium text-white hover:bg-brand-orange-hover"
          >
            返回首页并 release
          </button>
        </div>
      </div>
    </div>
  );
}
